import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import {forwardRef, useState} from "react";
import {CopyToClipboard} from "react-copy-to-clipboard/lib/Component";
import {IconButton, styled} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import {getTokenLinkUrl} from "../utils/portal-helper";
import {ApiUrl} from "../utils/portal-urls";
import {handleHttpResponse} from "../utils/http-helpers";

const StyledP = styled("p")({
    borderStyle: "solid",
    borderWidth: "thin",
    borderColor: "#d3d3d3",
    textAlign: "center",
    padding: "5px"
})

const Transition = forwardRef((props, ref) => (
    <Slide direction="up" ref={ref} {...props} />
    )
)

export default function OrganizationUserTokenLinkDialog(props) {
    const newUser = props.newUser;
    const tokenLink = props.tokenLink;

    const handleTokenLinkDialogClose = () => {
        props.close(false);
    }

    return (
        <div>
            <Dialog
                open={props.open}
                TransitionComponent={Transition}
                keepMounted
                maxWidth="lg"
                onClose={handleTokenLinkDialogClose}
            >
                {newUser && <DialogTitle>{`Successfully add ${newUser.givenName} ${newUser.familyName} to the portal`}</DialogTitle>}
                <DialogContent>
                    <div>
                        <p>
                            Please <strong>copy the link from below</strong> or <strong>click on the icon to copy the activation link</strong>:&nbsp;
                            <CopyToClipboard text={tokenLink}>
                                <IconButton>
                                    <ContentCopyIcon />
                                </IconButton>
                            </CopyToClipboard>
                        </p>
                        <StyledP>
                            {tokenLink}
                        </StyledP>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleTokenLinkDialogClose}>Close</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
